import Firebase from 'firebase'

const appConfig = {
  live: {
    authServer: 'https://www.enrollcoloniallife.com/email-auth/auth',
    platformNotFoundAPI: 'https://www.enrollcoloniallife.com/email-auth/dontseeyourplatform',
    firebase: {
      apiKey: 'AIzaSyBKT6g4cFNsdiGPQr3jWiJhNVoYOUqoAf4',
      authDomain: 'enrollment-platform-assistant.firebaseapp.com',
      databaseURL: 'https://enrollment-platform-assistant.firebaseio.com',
      projectId: 'enrollment-platform-assistant',
      storageBucket: 'enrollment-platform-assistant.appspot.com',
      messagingSenderId: '833098954394'
    }
  },
  test: {
    authServer: 'http://www.enrollcoloniallife.com.asp.cyberwoven.net/email-auth/auth',
    platformNotFoundAPI: 'http://www.enrollcoloniallife.com.asp.cyberwoven.net/email-auth/dontseeyourplatform',
    firebase: {
      apiKey: 'AIzaSyDej_5M9A-df9tovE4o-B8ywGYUXfwz9Wk',
      authDomain: 'coloniallifeeps.firebaseapp.com',
      databaseURL: 'https://coloniallifeeps.firebaseio.com',
      projectId: 'coloniallifeeps',
      storageBucket: 'coloniallifeeps.appspot.com',
      messagingSenderId: '313018588090'
    }
  },
  dev: {
    authServer: 'http://epsauth.dev.cyberwoven.local/Auth',
    platformNotFoundAPI: 'http://epsauth.dev.cyberwoven.local/email-auth/dontseeyourplatform',
    firebase: {
      apiKey: 'AIzaSyDej_5M9A-df9tovE4o-B8ywGYUXfwz9Wk',
      authDomain: 'coloniallifeeps.firebaseapp.com',
      databaseURL: 'https://coloniallifeeps.firebaseio.com',
      projectId: 'coloniallifeeps',
      storageBucket: 'coloniallifeeps.appspot.com',
      messagingSenderId: '313018588090'
    }
  }
}

let firebaseApp = process.env.NODE_ENV === 'production'
  ? Firebase.initializeApp(appConfig.live.firebase)
  : Firebase.initializeApp(appConfig.test.firebase)

export const db = firebaseApp.database()

export const sessionUrl = process.env.NODE_ENV === 'production'
  ? appConfig.live.firebase.databaseURL
  : appConfig.test.firebase.databaseURL

export const authServer = process.env.NODE_ENV === 'production'
  ? appConfig.live.authServer
  : appConfig.test.authServer

export const platformNotFoundAPI = process.env.NODE_ENV === 'production'
  ? appConfig.live.platformNotFoundAPI
  : appConfig.test.platformNotFoundAPI



// WEBPACK FOOTER //
// ./src/appConfig/appConfig.js